import React, { Component } from 'react';
import { connect } from 'react-redux';

import { setPageNumberDispatch } from '../actions/index';

class Pagination extends Component {
	handlePageNumClick(event) {
		event.preventDefault();
		let pageNum = 1;
		if (parseInt(event.target.getAttribute('data-pageNum'))) {
			pageNum = event.target.getAttribute('data-pageNum');
		}
		this.props.setPageNumberDispatch(pageNum);
	}

	handleNextClick(event) {
		event.preventDefault();
		let pageNum = parseInt(this.props.pagination.pageNum) + 1;
		this.props.setPageNumberDispatch(pageNum);
	}

	handlePrevClick(event) {
		event.preventDefault();
		let pageNum = parseInt(this.props.pagination.pageNum) - 1;
		this.props.setPageNumberDispatch(pageNum);
	}

	renderPageNumbers() {
		if (1 < parseInt(this.props.pagination.totalPages)) {
			let pageNumbers = [1, 2, 3, 4, 5, 6]; // default
			if (6 > parseInt(this.props.pagination.totalPages)) { // less than 6 pages
				pageNumbers = [];
				for (var i = 1; i <= parseInt(this.props.pagination.totalPages); i++) {
					pageNumbers.push(i);
				}
			} else if (parseInt(this.props.pagination.pageNum) > (parseInt(this.props.pagination.totalPages) - 6 )) { // less than 6 pages from the end
				pageNumbers = [];
				for (var i = (parseInt(this.props.pagination.totalPages) - 6 ); i <= parseInt(this.props.pagination.totalPages); i++) {
					pageNumbers.push(i);
				}
			} else if (3 < parseInt(this.props.pagination.pageNum)) { // somewhere in the middle
				pageNumbers = [];
				for (var i = (parseInt(this.props.pagination.pageNum) - 2 ); i <= (parseInt(this.props.pagination.pageNum) + 3 ); i++) {
					pageNumbers.push(i);
				}
			}

			return (pageNumbers.map(ind => {
					return (
						<button type="button" key={ind} className={(this.props.pagination.pageNum === ind) ? 'page-numbers current' : 'page-numbers'} onClick={this.handlePageNumClick.bind(this)} data-pageNum={ind}>{ind}</button>
					);
				})
			);
		}
	}

	renderPrevious() {
		if (1 < parseInt(this.props.pagination.pageNum)) {
			return (<button type="button" className="page-numbers"
			                onClick={ this.handlePrevClick.bind( this ) }>
				<i className="fa-solid fa-chevron-left"></i><span
				className="sr-only">Previous</span>
			</button>
			);
		}
	}

	renderNext() {
		if ( (parseInt( this.props.pagination.totalPages )
		     ) > parseInt(this.props.pagination.pageNum)) {
			return (<button type="button" className="page-numbers"
			                onClick={ this.handleNextClick.bind( this ) }>
				<i className="fa-solid fa-chevron-right"></i><span
				className="sr-only">Next</span>
			</button>
			);
		}
	}

	render() {
		return (<nav aria-label="" className="pagination">
			{ this.renderPrevious()}
			{this.renderPageNumbers()}
			{this.renderNext()}
		</nav>);
	}
}

function mapStateToProps( { pagination } ) {
	return { pagination };
}

export default connect( mapStateToProps, { setPageNumberDispatch } )( Pagination );